import { Component, HostListener, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { SelectMultipleComponent } from '../../shared/components/select-multiple/select-multiple.component';
import { FormFieldComponent } from '../../shared/components/form-field/form-field.component';
import { SlideTogglePadraoComponent } from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { Setor } from '../../shared/model/setor/setor.model';
import { SetorVinculoBase } from '../../shared/model/setor/setor-vinculo-base.model';
import { PlataformaModel } from '../../shared/model/plataforma-model';
import { BaseDinamica } from '../../shared/model/plataforma/base-dinamica.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../shared/service/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ValidacaoAlteracaoCampoService } from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import { MsgService } from '../../shared/service/msg.service';
import { PlataformaService } from '../../shared/service/plataforma.service';
import { SetorService } from '../../shared/service/setor.service';

@Component({
  selector: 'app-modal-cadastro-visualizacao-setor-component',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    SlideTogglePadraoComponent,
    FormFieldComponent,
    SelectMultipleComponent,
    MatIcon,
    MatTooltip,
    ReactiveFormsModule,
  ],
  templateUrl: './modal-cadastro-visualizacao-setor-component.component.html',
  styleUrl: './modal-cadastro-visualizacao-setor-component.component.css'
})
export class ModalCadastroVisualizacaoSetorComponent implements OnInit {

  visualizar = false;
  setor: Setor = new Setor();

  isCadastro = false;
  formSetor!: FormGroup;

  plataformas: PlataformaModel[] = [];
  carregandoPlataformas = false;

  plataformasSelecionadas: PlataformaModel[] = [];
  basesPorPlataforma: Record<number, BaseDinamica[]> = {};
  carregandoBasesPorPlataforma: Record<number, boolean> = {};
  basesSelecionadasPorPlataforma: Record<number, BaseDinamica[]> = {};

  private readonly dialog = inject(MatDialogRef<ModalCadastroVisualizacaoSetorComponent>);
  public data = inject<any>(MAT_DIALOG_DATA);
  private readonly authService = inject(AuthService);
  private readonly domSanitizer = inject(DomSanitizer);
  public alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly msgService = inject(MsgService);
  private readonly fb = inject(FormBuilder);
  private readonly plataformaService = inject(PlataformaService);
  private readonly setorService = inject(SetorService);

  constructor() {
    this.formSetor = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(1)]],
      descricao: ['', []],
    });
  }

  ngOnInit() {
    this.visualizar = this.data['visualizar'];
    this.setor = this.data['setor'];
    if (!this.setor.id) {
      this.setor = new Setor()
      this.isCadastro = true
      this.setor.ativo = true
    } else {
      this.isCadastro = false
      this.configurarSetorFormBuilder()
    }
    this.carregarPlataformas();
    this.alteracaoService.camposNaoAlterados();
  }

  protected configurarSetorFormBuilder() {
    this.formSetor.get('nome')?.patchValue(this.setor.nome);
    this.formSetor.get('descricao')?.patchValue(this.setor.descricao);
  }

  carregarPlataformas() {
    this.carregandoPlataformas = true;
    this.plataformaService.buscarPlataformasDoGrupo().subscribe({
      next: lista => {
        this.plataformas = lista ?? [];
        if (!this.isCadastro) {
          this.carregarBasesDoSetor();
        }
      },
      error: () => this.carregandoPlataformas = false,
      complete: () => this.carregandoPlataformas = false
    });
  }

  carregarBasesDoSetor() {
    if (!this.setor.id) { return; }
    this.setorService.buscarBasesDoSetor(this.setor.id).subscribe({
      next: vinculos => this.reconstruirSelecao(vinculos ?? [])
    });
  }

  private reconstruirSelecao(vinculos: SetorVinculoBase[]) {
    const porPlataforma = new Map<number, SetorVinculoBase[]>();
    vinculos.forEach(v => {
      if (!porPlataforma.has(v.plataformaId)) { porPlataforma.set(v.plataformaId, []); }
      porPlataforma.get(v.plataformaId)!.push(v);
    });

    const selecionadas: PlataformaModel[] = [];
    porPlataforma.forEach((lista, plataformaId) => {
      const plataforma = this.plataformas.find(p => p.id === plataformaId)
        ?? { id: plataformaId, nome: lista[0].plataformaNome };
      selecionadas.push(plataforma);
      this.basesSelecionadasPorPlataforma[plataformaId] = lista.map(v => ({
        id: v.idBase,
        uuid: v.uuidBase,
        nome: v.nome
      }));
      this.carregarBases(plataformaId);
    });
    this.plataformasSelecionadas = selecionadas;
  }

  onSelecionarPlataformas(lista: PlataformaModel[]) {
    this.plataformasSelecionadas = lista;
    this.alteracaoService.camposAlterado();

    const idsSelecionados = new Set(lista.map(p => p.id));
    Object.keys(this.basesSelecionadasPorPlataforma).forEach(key => {
      const plataformaId = Number(key);
      if (!idsSelecionados.has(plataformaId)) {
        delete this.basesSelecionadasPorPlataforma[plataformaId];
        delete this.basesPorPlataforma[plataformaId];
      }
    });

    lista.forEach(p => {
      if (p.id != null && !this.basesPorPlataforma[p.id]) {
        this.carregarBases(p.id);
      }
    });
  }

  carregarBases(plataformaId: number) {
    this.carregandoBasesPorPlataforma[plataformaId] = true;
    this.plataformaService.buscarBasesDinamicas(plataformaId).subscribe({
      next: bases => this.basesPorPlataforma[plataformaId] = bases ?? [],
      error: () => {
        this.basesPorPlataforma[plataformaId] = [];
        this.carregandoBasesPorPlataforma[plataformaId] = false;
      },
      complete: () => this.carregandoBasesPorPlataforma[plataformaId] = false
    });
  }

  onSelecionarBases(plataformaId: number, lista: BaseDinamica[]) {
    this.basesSelecionadasPorPlataforma[plataformaId] = lista;
    this.alteracaoService.camposAlterado();
  }

  removerBase(plataformaId: number, base: BaseDinamica) {
    const atual = this.basesSelecionadasPorPlataforma[plataformaId] ?? [];
    this.basesSelecionadasPorPlataforma[plataformaId] = atual.filter(b => b.id !== base.id);
    this.alteracaoService.camposAlterado();
  }

  private montarBasesSelecionadas(): SetorVinculoBase[] {
    const bases: SetorVinculoBase[] = [];
    Object.keys(this.basesSelecionadasPorPlataforma).forEach(key => {
      const plataformaId = Number(key);
      (this.basesSelecionadasPorPlataforma[plataformaId] ?? []).forEach(b => {
        bases.push({
          idBase: b.id,
          uuidBase: b.uuid,
          nome: b.nome,
          plataformaId: plataformaId
        });
      });
    });
    return bases;
  }

  prepararObj(){
    const formValue = this.formSetor.value;
    this.setor.nome = formValue.nome != undefined ? formValue.nome : this.setor.nome;
    this.setor.descricao = formValue.descricao != undefined ? formValue.descricao : this.setor.descricao;
    this.setor.bases = this.montarBasesSelecionadas();

    const objRetrorno: any = {
      setor: this.setor,
      isCadastro: this.isCadastro
    };
    this.dialog.close(objRetrorno);
  }

  salvar() {
    this.prepararObj()
  }

  cancelar() {
    this.dialog.close();
  }

  @HostListener('document:keydown.enter', ['$event'])
    handleEnterKey(): void {
      if(!this.formSetor.invalid){
        this.salvar();
      }else{
        this.msgService.msgAdvertencia('Termine de preencher os campos obrigatórios.');
      }
  }

}
